import Icon from '../components/Icon.vue'

Icon.register({
  guitar: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M502.6 39c5.2 5.2 9.3 15.3 9.3 22.6 0 7.3-4.2 17.5-9.4 22.6l-46.3 46.3c-3.2 3.3-9.4 7.1-13.8 8.5l-36.5 12.2-76.2 76.2c8.8 12.2 15.8 25.6 19.2 40.2 7.7 33.4 0.9 66.9-22 89.8-7.9 7.8-22.9 16.9-33.5 20.3-18.5 6-32.7 23.3-34.4 42.1-2.3 23.8-11.5 45.8-28.5 62.7-45.6 45.5-127.5 37.4-183-18.1-55.5-55.5-63.7-137.4-18-183 16.9-17 38.9-26.2 62.6-28.4 18.9-1.8 36.2-15.9 42.2-34.5 3.3-10.6 12.4-25.6 20.2-33.5 22.9-22.9 56.4-29.8 89.9-22 14.6 3.4 27.9 10.4 40.1 19.1l76.3-76.3 12.2-36.5c1.5-4.4 5.3-10.5 8.5-13.8l46.3-46.3c5.2-5.2 15.3-9.4 22.6-9.4 7.3 0 17.5 4.2 22.6 9.4zM208 352c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48z'
      }
    ]
  }
})
